import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const deletePlaylist = async ({
  playlistId,
  orgId,
}: {
  playlistId: string;
  orgId: string;
}): Promise<void> => {
  const response = await axiosClient.delete(
    `/${orgId}/playlists/${playlistId}`,
  );
  return response.data;
};

export function useDeletePlaylist(
  queryOptions?: Partial<
    UseMutationOptions<void, HttpError, { playlistId: string; orgId: string }>
  >,
) {
  return useMutation({
    mutationFn: deletePlaylist,
    ...queryOptions,
  });
}
